<template name="settlement">
	<div class="settlement_dialong">
		<!-- 核销完成 -->
		<el-dialog
		  title="温馨提示"
		  :visible.sync="show"
		  :before-close="close"
		  :close-on-click-modal="false"
		>
			<p class="tip">
				您确认核销该订单吗？核销后订单完成，状态不可撤销，请谨慎操作！
			</p>
			
			<div slot="footer">
				<el-button @click="close">取消</el-button>
				<el-button type="primary" @click="confirm" >确定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		settlement
	} from '@/api/order';
	export default {
		data() {
			return {
			};
		},
		props: {
			show: {
				type: Boolean,
				default: false
			},
			order_sn: {
				type: String,
				default: '',
			},
		},
		methods: {
			close() {
				this.$emit('close');
			},
			confirm() {
				settlement({
					order_sn: this.order_sn,
				}).then(res => {
					if (res.code == 0) {
						this.$message.success('操作成功');
						this.$emit('success');
					} else if(res.code == 40022 || res.code == 40081 || res.code == 40084){
						this.$message.error(res.message);
						this.$emit('close',true);
					} else {
						this.$message.error(res.message);
					}
				})
			},
		},
		mounted() {
			
		}
	}
</script>

<style scoped>
	.settlement_dialong .el-dialog__body {
		padding-top: 0;
		padding-bottom: 16px;
	}
	.settlement_dialong .el-dialog {
		width: 424px;
	}
	.settlement_dialong .tip {
		padding: 10px 20px;
		font-size: 14px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #333333;
		line-height: 24px;
	}
	.settlement_dialong .el-dialog__footer {
		padding-top: 0;
		padding-bottom: 16px;
	}
	
	.settlement_dialong .tip{
		font-size: 14px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #666666;
	}
</style>
